import { render, staticRenderFns } from "./addFactory.vue?vue&type=template&id=2f347e59&scoped=true&"
import script from "./addFactory.vue?vue&type=script&lang=js&"
export * from "./addFactory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f347e59",
  null
  
)

export default component.exports